var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-title fwb fs16 flex align-center"},[_c('span',{staticClass:"m-r-8"}),_vm._v(" "+_vm._s(_vm.title || 'title')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }